import { Controller } from "@hotwired/stimulus"

// Opens a <dialog> by id on click. Replaces inline
// onclick="document.getElementById('x').showModal()", which CSP blocks.
export default class extends Controller {
  static values = { id: String }

  open() {
    document.getElementById(this.idValue)?.showModal()
  }
}
